import script from "./AdminBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminBar.vue?vue&type=script&setup=true&lang=js"

import "./AdminBar.vue?vue&type=style&index=0&id=dd77b784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd77b784"]])

export default __exports__